import React, { Component } from "react";
import ListOfInvestors from "./ListofInvestors";
// import TableContainer from "./table";
import {
  INACTIVE_INVESTORS,
  NEW_INVESTORS,
  ACTIVE_INVESTORS,
} from "../../../store/types";
import { connect } from "react-redux";
import { TabletAndroidTwoTone } from "@material-ui/icons";
class ListOfInvestorsTabs extends Component {
  constructor(props) {
    super(props);
    const { active, value } = this.props.location.state;
    this.state = {
      active: active || INACTIVE_INVESTORS,
      value,
      tableData: [],
    };
  }

  componentWillMount() {
    this.getData();
  }

  async componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  getData = () => {
    const { active, value } = this.state;
    const { dashboardAUMData, sipSummaryData } = this.props;
    const data = !!dashboardAUMData
      ? active === NEW_INVESTORS
        ? dashboardAUMData.Table7
        : active === ACTIVE_INVESTORS
        ? dashboardAUMData.Table5
        : dashboardAUMData.Table6
      : [];

    const { Type } = this.props.location.state;
    const SipData = !!sipSummaryData
      ? active === NEW_INVESTORS
        ? sipSummaryData.Table6
        : active === ACTIVE_INVESTORS
        ? sipSummaryData.Table4
        : sipSummaryData.Table5
      : [];
    const tableData =
      Type === "SIP_SUMMARY"
        ? SipData.filter((item) => {
            return !!item.fund && item.fund.trim() === value.Fund.trim();
          })
        : data.filter((item) => {
            return !!item && item.fund.trim() === value.fund_code.trim();
          });
    this.setState({
      tableData,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { active } = prevState;
    if (active !== this.state.active) {
      this.getData();
    }
  }

  onChangeActive = (active) => () => {
    this.setState({
      active,
    });
  };

  render() {
    const { tableData } = this.state;
    const tablearray = [
      "Investor Name",
      // "Fund Name",
      "PAN",
      "Mobile Number",
      "Email Id",
    ];
    return (
      <div style={{ padding: 20, paddingBottom: 100 }}>
        <div className="investor-title">AUM Investors List</div>
        <ListOfInvestors
          active={this.state.active}
          onClick={this.onChangeActive}
        />
        <div className="investor-types-table">
          {!!tableData.length && (
            <div
              style={{
                backgroundColor: "rgba(245, 130, 32, 0.3)",
                display: "flex",
              }}
            >
              {tablearray.map((ele, index) => (
                <div
                  key={index}
                  style={{
                    width:
                      ele === "Investor Name" || ele === "Email Name"
                        ? "30%"
                        : "20%",
                    textAlign: "left",
                    padding: 10,
                    paddingTop: 13,
                    paddingBottom: 13,
                    fontSize: 14,
                  }}
                >
                  {ele}
                </div>
              ))}
            </div>
          )}

          {tableData.length > 0 ? (
            tableData.map((ele, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  backgroundColor: index % 2 === 0 ? "white" : "#fefbf7",
                  padding: 10,
                  paddingTop: 13,
                  paddingBottom: 13,
                }}
              >
                <div style={{ width: "30%", textAlign: "left" }}>
                  <div>{ele.name}</div>
                </div>

                {/* <div style={{ width: "25%" }}>
                  <div>{ele.funddesc}</div>
                </div> */}

                <div
                  style={{ width: "20%", textAlign: "left", paddingLeft: 6 }}
                >
                  <div>{ele.pangir}</div>
                </div>

                <div
                  style={{ width: "20%", textAlign: "left", paddingLeft: 9 }}
                >
                  <div>{ele.mobile}</div>
                </div>

                <div
                  style={{ width: "30%", textAlign: "left", paddingLeft: 14 }}
                >
                  <div>{ele.email}</div>
                </div>
              </div>
            ))
          ) : (
            <div
              style={{
                fontSize: 14,
                textAlign: "center",
                color: "red",
              }}
            >
              No Data Found
            </div>
          )}
        </div>
        <div className="mobile-aum-list">
          {tableData.length > 0 ? (
            tableData.map((ele, index) => (
              <InvestorTableCard
                key={index}
                invName={ele.name}
                mobile={ele.mobile}
                email={ele.email}
                pan={ele.pangir}
              />
            ))
          ) : (
            <div
              style={{
                fontSize: 14,
                textAlign: "center",
                color: "red",
              }}
            >
              {" "}
              No Data Found
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connect(({ dashboard }) => {
  const { dashboardAUMData, sipSummaryData } = dashboard;
  return { dashboardAUMData, sipSummaryData };
}, null)(ListOfInvestorsTabs);

export class InvestorTableCard extends Component {
  render() {
    const { invName, pan, mobile, email } = this.props;
    return (
      <div
        style={{
          background: "white",
          border: "1px solid rgba(211,211,211,0.3)",
          padding: "7px 10px",
          margin: "10px 0px",
        }}
      >
        <div
          style={{
            color: "#005DAC",
            fontSize: 14,
            paddingBottom: 5,
            borderBottom: "1px solid rgba(211,211,211,0.3)",
          }}
        >
          {invName}
        </div>

        <div style={{ display: "flex", padding: "8px 0px" }}>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontSize: 12 }}>PAN</div>
            <div
              style={{
                fontSize: 13,
                color: "#194b7e",
              }}
            >
              {!!pan ? pan : "NA"}
            </div>
          </div>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontSize: 12 }}>Mobile</div>
            <div
              style={{
                fontSize: 13,
                color: "#194b7e",
              }}
            >
              {!!mobile ? mobile : "NA"}
            </div>
          </div>
        </div>
        <div>
          <div style={{ fontSize: 12 }}>Email</div>
          <div
            style={{
              fontSize: 13,
              color: "#194b7e",
            }}
          >
            {!!email ? email : "NA"}
          </div>
        </div>
      </div>
    );
  }
}
